// extracted by mini-css-extract-plugin
export default {"customQuotationOption":"CreatePo_customQuotationOption__UFn0l"};